module.exports = __webpack_public_path__ + "static/media/Justice-amico.204a0524.svg";